// TailwindScope.tsx
export function TailwindScope({ children }: { children: React.ReactNode }) {
    return <div className="tw-scope">{children}</div>
  }
  